module.exports = __webpack_public_path__ + "media/images/favicon-8af6edf0b15469ed87856396b705fd56.svg";